export var EXTERNAL_URLS = {
    CONTACT_YODLEE: "https://www.yodlee.com/company/contact-us"
};
//# sourceMappingURL=url.js.map